export const resolve_relations = "featured_team_section.team_members,practice_area"
